import type { CircuitPathsState } from "../../../ReviewPage/hooks/useCircuitCablePaths/types";
import { isolatedCircuitId } from "./isolatedCircuitId";
import type { VisibleCablePaths } from "./types";

/** Frozen: this is a memo dependency all the way down to the SVG layer. */
export const NO_CABLE_PATHS: CircuitPathsState = Object.freeze({
  paths: [],
  distributionBoardPosition: null,
}) as CircuitPathsState;

export const visibleCablePaths: VisibleCablePaths = ({
  geometry,
  grabbedKind,
  isBoardsStep = false,
  hoveredCircuitId,
  routeUnderReview,
  selectedCircuitId,
}) => {
  if (!geometry) return null;
  // While a feed point is being placed the drawing has to be readable enough to
  // click on, and 83 circuits over it are not.
  if (grabbedKind === "source" || isBoardsStep) return NO_CABLE_PATHS;

  const active = isolatedCircuitId({
    geometry,
    hoveredCircuitId,
    routeUnderReview,
    selectedCircuitId,
  });
  if (active) return geometry.byCircuit[active];

  // The "draw every cable" switch deliberately does NOT drop the paths: it
  // hides the CABLES, and the layer still draws every device at the end of one,
  // in its own run's colour. Returning nothing here left him a blank plan,
  // which is not what "too messy when all is drawn" asked for.
  return geometry.all;
};
